<!-- Filename: components/LoginPopover.svelte -->
<!--Before da Shits -->
<!-- Filename: components/LoginPopover.svelte -->
<!-- Latest WORKing version-->

<script>
    import { createEventDispatcher, onMount, afterUpdate } from "svelte";
    import { db, isWLtriggered, emailHash, modesData } from "../stores.js";
    import { baseURL } from "../config.js"

    const dispatch = createEventDispatcher();
    let email = "";
    let password = "";
    let isLoading = false; // State to manage loading
    let needPassword = false;
    let showPassword = false; // State to toggle password visibility
    let GPTisStupidLoading = true; // Initialize it to true to show the loading animation initially
    let focusHasBeenSet = false; // Flag to control focus behavior
    let passwordInput;

    let focusSet = false; // Flag to track if focus has been set


    export let chatToken;

    //BEFORE JEREMY CHANGES

    let displayPopover = false;
    let isADLoading = true;


//    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;


    function isValidEmail(emailToValidate) {
        return emailRegex.test(emailToValidate);
    }


/*    onMount(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const potentialEmail = urlParams.get('email');

        // If an email parameter exists, regardless of its validity
        if (potentialEmail !== null) {
            if (isValidEmail(potentialEmail)) {
                email = potentialEmail; // Assign valid email to global variable
                displayPopover = false; // Valid email present, do not display popover
                console.log("this is email:", email, `\nthis is chatToken:`, chatToken);
                handleEmailSubmission(); // Proceed with automatic login
            } else {
                displayPopover = false; // Invalid email present, do not display popover
                alert("Invalid query string for email"); // Notify the user of the invalid email
            }
        } else {
            displayPopover = true; // Display popover if no email query parameter is present
        }
    });*/


    onMount(async () => {
        function isProblematicBrowser() {
            const ua = navigator.userAgent;

            // Check for Android devices
            const isAndroid = /Android/.test(ua);
            const isChromeAndroid = isAndroid && /Chrome/.test(ua);
            const isFirefoxAndroid = isAndroid && /Firefox/.test(ua);

            // Check for iOS devices
            const isIOS = /iPhone|iPad|iPod/.test(ua);
            const isChromeIOS = isIOS && /CriOS/.test(ua);
            const isFirefoxIOS = isIOS && /FxiOS/.test(ua);
            const isSafariIOS = isIOS && !isChromeIOS && !isFirefoxIOS;

            // Return true if any of the problematic browsers are detected
            return isChromeAndroid || isFirefoxAndroid || isChromeIOS || isFirefoxIOS || isSafariIOS;
        }

        if (isProblematicBrowser()) {
            document.documentElement.style.setProperty('--extra-margin', '8vh');
        } else {
            document.documentElement.style.setProperty('--extra-margin', '0px');
        }



    // New auth step: Assess deployment
    try {
      const response = await fetch(`${baseURL}/api/assess-deployment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ chatToken }) // Send chatToken in the body of the POST request
      });
      const data = await response.json();

      // Log the full response data in a readable format
//      console.log("Response from assess-deployment:", JSON.stringify(data, null, 2));

      if (data.endpointV) {
        // Assume data contains { endpointV: true, key1: value1, key2: value2, ... }
//        someStore.set(data.key1);
//        anotherStore.set(data.key2);
        // Update other stores as needed and dispatch a function
//        dispatchCustomFunction(); // Replace with your actual function

        await firebase.auth().signInWithCustomToken(data.customToken);
        
        isADLoading = false;  // Set loading to false when the fetch completes
        
        dispatch("login2", { completeShit: data.completeShit });
        return; // Stop further execution to prevent entering email auth flow
      }
    } catch (error) {
      console.error('Failed to assess deployment:', error);
    }


        isADLoading = false;



    // Existing email-based auth flow

        const queryString = window.location.search;
        let potentialEmail = null;

        console.log("this is queryString", queryString)

        // Manually extract the email parameter from the query string
//        const emailMatch = queryString.match(/[\?&]email=([^&]+)/);//
        const emailMatch = queryString.match(/^[?&]email=(.*)$/);
        if (emailMatch) {
            potentialEmail = emailMatch[1];
        }
        console.log("this is emailMatch", emailMatch)

        console.log("This is potential Email BEFORE:", potentialEmail);
//        console.log("This is potential Email AFTER:", potentialEmail);
        console.log("Is it a valid email query string?", isValidEmail(potentialEmail));

        // Check if the potentialEmail is valid before assigning it globally and proceeding
        if (potentialEmail && isValidEmail(potentialEmail)) {
            email = potentialEmail; // Assign to global email variable only after validation
            displayPopover = false; // Do not display popover since valid email is present
//            console.log("this is email:", email, `\nthis is chatToken:`, chatToken);
            handleEmailSubmission(); // Proceed with automatic login
        } else {
            displayPopover = true; // Only display popover if no valid email is present
        }



    });




    async function postCheckWhitelistStatus(chatToken) {
        try {
            const response = await fetch(
                `${baseURL}/api/checkWhitelistStatus2`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ chatToken }),
                },
            );

            if (!response.ok) {
                throw new Error(`Server error: ${response.statusText}`);
            }

            const data = await response.json();
            console.log("isWLtriggered:", data.isWLtriggered); // Log isWLtriggered value
            isWLtriggered.set(data.isWLtriggered);
            GPTisStupidLoading = false; // Assuming this is set after the fetch call
        } catch (error) {
            console.error("Error:", error);
        }
    }

    async function handleLogin() {
        if (!isValidEmail(email)) {
            console.error("Invalid email format:", email);
            alert("Invalid Email format!");
            // Add UI feedback or error message here
            return;
        }
        isLoading = true; // Start loading

        try {
            const response = await fetch(
                `${baseURL}/api/clientSubUserLogin2`,
                {
                    method: "POST",
                    mode: "cors",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ email, password, chatToken }),
                },
            );

            // Check if the response is ok (status in the range 200-299)
            if (!response.ok) {
                // Attempt to read the response as JSON first
                let message = "Unknown error occurred";
                if (
                    response.headers
                        .get("Content-Type")
                        ?.includes("application/json")
                ) {
                    const errorData = await response.json();
                    message = errorData.message || "Unknown error";
                } else {
                    // If not JSON, use a generic error message or parse differently
                    message = "Service unavailable or wrong endpoint";
                }
                throw new Error(
                    `Server error (${response.status}): ${message}`,
                );
            }

            const data = await response.json();
            if (data.status !== "success") {
                throw new Error(
                    data.message || "Login failed for an unknown reason.",
                );
            }

            // Proceed with Firebase authentication and dispatch event
            await firebase.auth().signInWithCustomToken(data.customToken);
            dispatch("login", {
                userEmailHash: data.emailHash,
                newUser: data.newUser,
            });
        } catch (error) {
            console.error("Authentication error:", error);
            alert(`Authentication error: ${error.message}`);
        } finally {
            isLoading = false; // Reset loading state regardless of outcome
        }
    }

    async function handleLoginWithEmail() {
        isLoading = true; // Start loading

        if (!isValidEmail(email)) {
            console.error("Invalid email format:", email);
            alert("Invalid Email format!");
            // Add UI feedback or error message here
            return;
        }

        try {
            const response = await fetch(
                `${baseURL}/api/clientSubUserLogin`,
                {
                    method: "POST",
                    mode: "cors",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ email, chatToken }),
                },
            );

            // Check if the response is ok (status in the range 200-299)
            if (!response.ok) {
                // Attempt to read the response as JSON first
                let message = "Unknown error occurred";
                if (
                    response.headers
                        .get("Content-Type")
                        ?.includes("application/json")
                ) {
                    const errorData = await response.json();
                    message = errorData.message || "Unknown error";
                } else {
                    // If not JSON, use a generic error message or parse differently
                    message = "Service unavailable or wrong endpoint";
                }
                throw new Error(
                    `Server error (${response.status}): ${message}`,
                );
            }

            const data = await response.json();
            if (data.status !== "success") {
                throw new Error(
                    data.message || "Login failed for an unknown reason.",
                );
            }

            // Proceed with Firebase authentication and dispatch event
            await firebase.auth().signInWithCustomToken(data.customToken);
            dispatch("login", {
                userEmailHash: data.emailHash,
                newUser: data.newUser,
            });
        } catch (error) {
            console.error("Authentication error:", error);
            alert(`Authentication error: ${error.message}`);
        } finally {
            isLoading = false; // Reset loading state regardless of outcome
        }
    }

    function togglePasswordVisibility() {
        showPassword = !showPassword;
    }

    function closePopover() {
        dispatch("close");
    }
/*
    async function handleSubmitEmail() {
        if (!email) {
            userMessage = "Please enter a valid email."; // Basic validation message
            return;
        }
        isLoading = true;
        try {
            const response = await fetch("/dummy-endpoint", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });
            const data = await response.json();
            // Assume data structure: { requirePassword: boolean, message: string }
            needPassword = data.requirePassword;
            userMessage = data.message; // This could be instructions to check email, etc.
            if (!needPassword) {
                // Maybe do something here, like redirect, or handle token
            }
        } catch (error) {
            console.error("Error submitting email:", error);
            userMessage = "Failed to submit. Please try again.";
        } finally {
            isLoading = false;
        }
    }

    async function handlePasswordSubmit() {
        if (!password) {
            userMessage = "Please enter your password."; // Basic validation for password
            return;
        }
        //isLoading = true;
        // Logic to handle password submission, similar to the email submission logic
        // Placeholder for now
        isLoading = false;
    } */

//WTF is this man

    // Function to handle initial email submission
async function handleEmailSubmission() {
    if (!isValidEmail(email)) {
        alert("Invalid Email format!");
        return;
    }
    email = email.toLowerCase();
    isLoading = true;

    try {
        const response = await fetch(`${baseURL}/api/dynamicClientSubUserLogin`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, chatToken }), // Assume chatToken or other necessary data is included here
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || "An error occurred");
        }

        switch (data.status) {
            case 'success':
                if (data.redirectPage === 'loginPropBro') {
                    isWLtriggered.set(true);
                    needPassword = true;
                    if (!displayPopover) {
                        alert('This is a Whitelisted deployment. Please turn Whitelist off to use query strings.')
                    }
                } else if (data.action === 'promptToCheckEmail') {
                    alert("Please check your email to confirm your account.");
                } else if (data.customToken) {
                    await firebase.auth().signInWithCustomToken(data.customToken);
                    console.log("We logged in with stuff. This is emailHash:", data.emailHash)
                    const idTokenResult = await firebase.auth().currentUser.getIdTokenResult();
                    console.log(idTokenResult.claims); // Logs the claims of the current token
                    console.log("This is modesShit:", data.modesData, `\nThis is splashScreenShit:`, data.splashScreenData)
                    // New logic to directly use modesData if it exists
                    if (data.modesData && Object.keys(data.modesData).length > 0) {
                        const modesMap = new Map(Object.entries(data.modesData));
                        modesData.set(modesMap); // Update the Svelte store with the new data
                    }


                    dispatch("login", { success: true, newUser: data.newUser, userEmailHash: data.emailHash });
                }
                break;
            case 'error':
                alert(data.message);
            break;
            default:
                throw new Error("Unexpected response status");
        }
    } catch (error) {
        console.error("Login error:", error);
                if (!displayPopover) {
                    if (error.message === "Email or password is invalid") {
                        alert('This is a Whitelisted deployment. Please turn Whitelist off to use query strings.');
                    } else {
                        alert("Please try again in a bit. If it doesn't work, please open a support ticket.");
                    }
                } else {
                    alert(error.message);
                }
//        alert(error.message);
    } finally {
        isLoading = false;
    }
}



    // Function to handle the full login, including password if necessary
async function handleLoginFucker() {
    if (!isValidEmail(email) || (needPassword && password.trim().length === 0)) {
        alert("Please ensure all fields are correctly filled.");
        return;
    }

    email = email.toLowerCase();

    isLoading = true;

    try {
        const response = await fetch(`${baseURL}/api/dynamicClientSubUserLogin`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password, chatToken }), // Now including password in the request
        });
        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || "An error occurred");
        }

        if (data.status === 'success' && data.customToken) {
            await firebase.auth().signInWithCustomToken(data.customToken);
            if (data.modesData && Object.keys(data.modesData).length > 0) {
                const modesMap = new Map(Object.entries(data.modesData));
                modesData.set(modesMap); // Update the Svelte store with the new data
            }

            dispatch("login", { success: true, newUser: data.newUser, userEmailHash: data.emailHash });
        } else if (data.status === 'error') {
            alert(data.message);
        } else if (data.action === 'promptToCheckEmail') {
            alert("Please check your email to confirm your account.");
        } else {
            throw new Error("Unexpected response status");
        }
    } catch (error) {
        console.error("Authentication error:", error);
        alert(error.message);
    } finally {
        isLoading = false;
    }
}


    // Directly handle key press for form submission
    function handleKeyPress(event) {
        if (event.key === 'Enter') {
            event.preventDefault(); // Prevent the default form action
            needPassword ? handleLoginFucker() : handleEmailSubmission();
        }
    }

    // Directly focus the password input after updates, if conditions are met
    afterUpdate(() => {
        if (needPassword && passwordInput && !focusSet) {
            passwordInput.focus();
            focusSet = true; // Set the flag to true after focusing
        }
    });

/*
    onMount(() => {
        const path = window.location.pathname.split("/");
        const chatToken = path[path.length - 1];
        if (chatToken) {
            postCheckWhitelistStatus(chatToken);
        }
    });
*/

/*
    onMount(() => {
        function isProblematicBrowser() {
            const ua = navigator.userAgent;

            // Check for Android devices
            const isAndroid = /Android/.test(ua);
            const isChromeAndroid = isAndroid && /Chrome/.test(ua);
            const isFirefoxAndroid = isAndroid && /Firefox/.test(ua);

            // Check for iOS devices
            const isIOS = /iPhone|iPad|iPod/.test(ua);
            const isChromeIOS = isIOS && /CriOS/.test(ua);
            const isFirefoxIOS = isIOS && /FxiOS/.test(ua);
            const isSafariIOS = isIOS && !isChromeIOS && !isFirefoxIOS;

            // Return true if any of the problematic browsers are detected
            return isChromeAndroid || isFirefoxAndroid || isChromeIOS || isFirefoxIOS || isSafariIOS;
        }

        if (isProblematicBrowser()) {
            document.documentElement.style.setProperty('--extra-margin', '8vh');
        } else {
            document.documentElement.style.setProperty('--extra-margin', '0px');
        }
    });
*/

</script>

<div class="overlay">
            {#if (!displayPopover && isLoading) || isADLoading}
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="337px" height="337px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="rotate(0 50 50)"><rect x="47.5" y="25.5" rx="1.8900000000000001" ry="1.8900000000000001" width="5" height="9" fill="#0f264a"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.9166666666666666s" repeatCount="indefinite"></animate></rect></g><g transform="rotate(30 50 50)"><rect x="47.5" y="25.5" rx="1.8900000000000001" ry="1.8900000000000001" width="5" height="9" fill="#0f264a"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.8333333333333334s" repeatCount="indefinite"></animate></rect></g><g transform="rotate(60 50 50)"><rect x="47.5" y="25.5" rx="1.8900000000000001" ry="1.8900000000000001" width="5" height="9" fill="#0f264a"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.75s" repeatCount="indefinite"></animate></rect></g><g transform="rotate(90 50 50)"><rect x="47.5" y="25.5" rx="1.8900000000000001" ry="1.8900000000000001" width="5" height="9" fill="#0f264a"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.6666666666666666s" repeatCount="indefinite"></animate></rect></g><g transform="rotate(120 50 50)"><rect x="47.5" y="25.5" rx="1.8900000000000001" ry="1.8900000000000001" width="5" height="9" fill="#0f264a"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5833333333333334s" repeatCount="indefinite"></animate></rect></g><g transform="rotate(150 50 50)"><rect x="47.5" y="25.5" rx="1.8900000000000001" ry="1.8900000000000001" width="5" height="9" fill="#0f264a"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.5s" repeatCount="indefinite"></animate></rect></g><g transform="rotate(180 50 50)"><rect x="47.5" y="25.5" rx="1.8900000000000001" ry="1.8900000000000001" width="5" height="9" fill="#0f264a"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.4166666666666667s" repeatCount="indefinite"></animate></rect></g><g transform="rotate(210 50 50)"><rect x="47.5" y="25.5" rx="1.8900000000000001" ry="1.8900000000000001" width="5" height="9" fill="#0f264a"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.3333333333333333s" repeatCount="indefinite"></animate></rect></g><g transform="rotate(240 50 50)"><rect x="47.5" y="25.5" rx="1.8900000000000001" ry="1.8900000000000001" width="5" height="9" fill="#0f264a"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.25s" repeatCount="indefinite"></animate></rect></g><g transform="rotate(270 50 50)"><rect x="47.5" y="25.5" rx="1.8900000000000001" ry="1.8900000000000001" width="5" height="9" fill="#0f264a"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.16666666666666666s" repeatCount="indefinite"></animate></rect></g><g transform="rotate(300 50 50)"><rect x="47.5" y="25.5" rx="1.8900000000000001" ry="1.8900000000000001" width="5" height="9" fill="#0f264a"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="-0.08333333333333333s" repeatCount="indefinite"></animate></rect></g><g transform="rotate(330 50 50)"><rect x="47.5" y="25.5" rx="1.8900000000000001" ry="1.8900000000000001" width="5" height="9" fill="#0f264a"><animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animate></rect></g><!-- [ldio] generated by https://loading.io/ --></svg>
            {/if}

{#if displayPopover}

        <div class="login-popover">
            {#if isLoading}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    style="margin: auto; display: block; shape-rendering: auto;"
                    width="200px"
                    height="200px"
                    viewBox="0 0 100 100"
                    preserveAspectRatio="xMidYMid"
                >
                    <circle
                        cx="50"
                        cy="50"
                        r="0"
                        fill="none"
                        stroke="#e93f0c"
                        stroke-width="2"
                    >
                        <animate
                            attributeName="r"
                            repeatCount="indefinite"
                            dur="0.819672131147541s"
                            values="0;40"
                            keyTimes="0;1"
                            keySplines="0 0.2 0.8 1"
                            calcMode="spline"
                            begin="0s"
                        ></animate>
                        <animate
                            attributeName="opacity"
                            repeatCount="indefinite"
                            dur="0.819672131147541s"
                            values="1;0"
                            keyTimes="0;1"
                            keySplines="0.2 0 0.8 1"
                            calcMode="spline"
                            begin="0s"
                        ></animate>
                    </circle><circle
                        cx="50"
                        cy="50"
                        r="0"
                        fill="none"
                        stroke="#004354"
                        stroke-width="2"
                    >
                        <animate
                            attributeName="r"
                            repeatCount="indefinite"
                            dur="0.819672131147541s"
                            values="0;40"
                            keyTimes="0;1"
                            keySplines="0 0.2 0.8 1"
                            calcMode="spline"
                            begin="-0.4098360655737705s"
                        ></animate>
                        <animate
                            attributeName="opacity"
                            repeatCount="indefinite"
                            dur="0.819672131147541s"
                            values="1;0"
                            keyTimes="0;1"
                            keySplines="0.2 0 0.8 1"
                            calcMode="spline"
                            begin="-0.4098360655737705s"
                        ></animate>
                    </circle>
                    <!-- [ldio] generated by https://loading.io/ --></svg
                >
            {/if}

            <input
                type="email"
                placeholder="Enter your email"
                bind:value={email}
                on:keydown={handleKeyPress}
                class="input"
            />
            {#if needPassword}
                <div class="password-container">
                    {#if showPassword}
                        <input
                            type="text"
                            placeholder="Enter your password"
                            bind:value={password}
                            on:keydown={handleKeyPress}
                            class="input"
                            bind:this={passwordInput}
                        />
                    {:else}
                        <input
                            type="password"
                            placeholder="Enter your password"
                            bind:value={password}
                            on:keydown={handleKeyPress}
                            class="input"
                            bind:this={passwordInput}
                        />
                    {/if}
                    <span
                        class="toggle-password"
                        on:click={togglePasswordVisibility}
                    >
                        <i
                            class={showPassword
                                ? "fas fa-eye-slash"
                                : "fas fa-eye"}
                        ></i>
                    </span>
                </div>
            {/if}
            <button on:click={needPassword ? handleLoginFucker : handleEmailSubmission} class="button">
                {needPassword ? 'Login' : 'Submit'}
            </button>
        </div>

{/if}


</div>

<style>
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(5px);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
    }
    .login-popover {
        background-color: white;
        padding: 20px;
        border-radius: 10px;
        z-index: 11;
    }
    .input {
        width: 100%;
        padding: 10px;
        margin-bottom: 10px;
        border: 1px solid #ccc;
        border-radius: 5px;
    }
    .password-container {
        display: flex;
        align-items: center;
        position: relative;
    }
    .toggle-password {
        position: absolute;
        right: 10px;
        cursor: pointer;
        background: none;
        border: none;
    }
    .button {
        display: block;
        width: 100%;
        padding: 10px;
        background-color: #195cc0;
        color: white;
        border: none;
        border-radius: 20px;
        cursor: pointer;
    }
    .button:hover {
        background-color: #103875;
    }
    .button:disabled {
        background-color: #ccc;
        color: #767676;
        cursor: not-allowed;
    }
</style>
